import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import MainLayout from 'src/layouts/main';

const HelpIndexPage = lazy(() => import('src/pages/help/index'));

export const helpRoutes = [
  {
    path: '/help',
    element: (
      <MainLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),
    children: [{ element: <HelpIndexPage />, index: true }],
  },
];
